import React from "react";
import CustomTable from "../../../../../components/table/CustomTable";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {CheckOutlineIcon} from "../../../../../components/buttons/IconButtons";
import {MaterialRequestTableApp} from "../../Functionality/MaterialRequest/MaterialRequestTableApp";
import {MaterialRequestHeader} from "./MaterialRequestHeader";
import CancelModal from "../../../Dining/Schedules/Modal/CancelModal";
import {getInfoParagraphByStatus} from "../../../ApprovalTracker/Model/Model";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MaterialRequestTable = ({
    optionView,
    handleBtnRequest,
    handleBtnHistory,
    selectedList,
    setSelectedList,
    isAllChecked,
    setIsAllChecked,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSearch,
    simpleSearch,
    setSimpleSearch,
    finalArray,
    modified,
    setModified,
    setCriteria
}) => {
    const {
        t,
        handleDeleteAll,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        getActionsButtons,
        pagination,
        rowsPerPage,
        results,
        setResults,
        listDisabled,
        showApproveButton,
        showApprovedModal,
        setShowApprovedModal,
        handleApprovalAll,
        getData
    } = MaterialRequestTableApp({
        selectedList,
        setSelectedList,
        setIsAllChecked,
        option,
        setBodyForExport,
        searchElement,
        finalArray,
        modified,
        setModified,
        setCriteria,
    });

    return (
        <>
            <MaterialRequestHeader
                optionView={optionView}
                handleBtnRequest={handleBtnRequest}
                handleBtnHistory={handleBtnHistory}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setResults={setResults}
                results={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                getData={getData}
            />
            {/* The row of the approval is only rendered when there is something
                to approve, so an empty table keeps the same spacing the history
                of the requests is read with */}
            {showApproveButton && (
                <div className='d-flex justify-content-end px-4 mt-4'>
                    <ButtonAction
                        Icon={CheckOutlineIcon}
                        id={'btn_mrt_approve'}
                        extraClassName={'border-full-success-600 background-general-00'}
                        className={'border-full-success-600 background-general-00'}
                        iconClass={'h-32px w-32px mr-0'}
                        iconProps={'icon'}
                        onClick={() => {
                            setShowApprovedModal(true);
                        }}
                    />
                </div>
            )}
            <div className={"mt-3"}>
                <CustomTable tableId={tableId}
                             searchId={searchId}
                             checkbox={listDisabled.length !== tbody?.data?.length}
                             checkboxTitle={"de_/_select_all"}
                             isAllChecked={isAllChecked}
                             onChangeCheckbox={handleDeleteAll}
                             thead={thead}
                             tbody={tbody}
                             columnActions={true}
                             getActionsButtons={getActionsButtons}
                             handleCheckboxChange={handleCheckboxChange}
                             selectedList={selectedList}
                             listDisabled={listDisabled}
                             textNotInformation={'you_dont_have_any_requests_yet'}
                />
                {pagination()}
            </div>

            {showApprovedModal && (
                <CancelModal
                    show={showApprovedModal}
                    onHide={() => {
                        setShowApprovedModal(false);
                        setSelectedList([]);
                        setIsAllChecked(false);
                    }}
                    onConfirm={(e, comment) => {
                        handleApprovalAll(comment)
                    }}
                    requiredComment={false}
                    title_modal={"approve_request"}
                    description={t("are_you_sure_to_proceed")}
                    subDescription={t(getInfoParagraphByStatus(STATUS_MODEL.APPROVED))}
                />
            )}
        </>
    );
};

export default MaterialRequestTable;
